// /packages/shared-ui/utils/token.ts
import { jwtDecode } from "jwt-decode";
import { fetchAuthSession } from "aws-amplify/auth";

// 現在のセッションを取得する関数
export const validSessionToken = async (): Promise<
  | {
      idToken: string;
      accessToken: string;
    }
  | undefined
> => {
  // 現在のセッションを取得
  const ses = await fetchAuthSession();

  // トークンが存在しない場合
  if (!ses || !ses.tokens || !ses.tokens.idToken || !ses.tokens.accessToken)
    return;

  // トークンが有効期限切れの場合
  const idToken = ses.tokens.idToken.toString();
  const accessToken = ses.tokens.accessToken.toString();
  if (isTokenExpired(idToken) || isTokenExpired(accessToken)) return;

  return {
    idToken,
    accessToken,
  };
};

export function isTokenExpired(token: string): boolean {
  const decoded: { exp: number } = jwtDecode(token);
  const now = Math.floor(Date.now() / 1000);
  return decoded.exp < now;
}
